import { Box } from '@mui/material';
import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { OnlineDetectionNotifier } from 'shared/components/OnlineDetectionNotifier';
import { useStyles } from './SlimLayout.styles';

export const SlimLayout: FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Outlet />

      <OnlineDetectionNotifier />
    </Box>
  );
};
